import { styled } from '@mui/material';

interface RequiredStarProps {
  error?: boolean;
  disabled?: boolean;
}

const RequiredStarStyled = styled('div')<RequiredStarProps>(({ theme }) => ({
  position: 'absolute',
  fontSize: '1.1rem',
  lineHeight: 1,
  top: '3px',
  right: '6px',
  height: 0,
  color: theme.palette['icon-grey-400'],

  variants: [
    {
      props: { error: true },
      style: { color: theme.palette['icon-red-100'] },
    },
    {
      props: { disabled: true },
      style: {
        color: theme.palette['icon-grey-300'],
      },
    },
  ],
}));

export const RequiredStar = (props: RequiredStarProps) => {
  const { error, disabled } = props;

  return (
    <RequiredStarStyled disabled={disabled} error={error}>
      *
    </RequiredStarStyled>
  );
};
